
































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName, successAndPush, errorAndPush} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import TipoPessoaRecebedor from '../../model/resource/TipoPessoaRecebedor'
import {Role} from '../../enums/Role'

const metaInfo = () => ({
    title: $.t('view.manage.personTypeList.title'),
})

@Component({
    metaInfo,
})
export default class ManagePersonTypeListView extends Mixins(MixinFilter, MixinSelect) {
    @Getter('auth/responsavel') user!: Responsavel
    @Getter('auth/role') role!: Role

    Role = Role
    AppConfig = AppConfig
    pushByName = pushByName

    collection = new PageCollection(TipoPessoaRecebedor, {}, 10)

    created() {
        this.collection.endpoint = '/user/tipo-recebedor-pessoa/responsavel'
    }

  async deletePersonType(item: TipoPessoaRecebedor) {
    try {
      const tipo = new TipoPessoaRecebedor()
      await tipo.removeResponsavelDeTipoPessoaRecebedor(Number(item.$id))
      await this.collection.query()
      successAndPush('system.success.unlinkResponsible', '/manage/person-type/list')
    } catch (error) {
      console.error('deletePersonType error:', error)
      errorAndPush('system.error.unlinkResponsibleError', '/manage/person-type/list')
    }
  }
}
